import script from "./detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail.vue?vue&type=script&lang=ts&setup=true"

import "./detail.scss?vue&type=style&index=0&id=9447794e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9447794e"]])

export default __exports__